module.exports = __webpack_public_path__ + "img/FORD_DT.5ff18568.png";